<template>
    <div class="all">
        <div class="page suo clearfix">
            <div class="page-left wh70">
                <div class="kuang pd24 map-bg h576">
                    <div class="left-number fl">
                        <div class="item">
                            <router-link :to="{path:'/analysis/informationSet?dayType=6&startDate='+startDate+'&endDate='+endDate}">
                            <!-- <router-link to="/analysis/informationSet?dayType=6"> -->
                                <span class="db">信息累计总量(近一个月)</span>
                                <span class="db num">{{numData.allTotal}}</span>
                            </router-link>
                        </div>
                        <div class="item">
                            <router-link :to="{path:'/analysis/analysisDetail?type=mainMedia&startDate='+startDate+'&endDate='+endDate}">
                                <span class="db">互联网新闻信息稿源量(近一个月)</span>
                                <span class="db num">{{numData.mediaCount}}</span>
                            </router-link>
                        </div>
                        <div class="item">
                            <router-link to="/analysis/informationSet?dayType=1">
                                <span class="db">今日信息量</span>
                                <span class="db num">{{numData.todayCount}}</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="home-map hidden">
                        <div class="echart-warp">
                            <homeMapChart :showTimeLong="6" id="homeMapChart" :startDate='startDate' :endDate='endDate' :dataArray="homeMapChartData" v-if="homeMapChartData != ''" jump="pubArea"></homeMapChart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-right wh30">
                <div class="kuang h278">
                    <div class="round-warp">
                        <div class="round round2"></div>
                        <div class="round round1"></div>
                    </div>
                    <homePieChart :showMonthData="true" id="homePieChart1" :dataArray="homePieChartData1" v-if="homePieChartData1 !=''" jump="platformType"></homePieChart>
                </div>
                <div class="kuang mt20 h278">
                    <div class="round-warp">
                        <div class="round round2"></div>
                        <div class="round round1"></div>
                    </div>
                    <homePieChart :showMonthData="true" id="homePieChart2" :dataArray="homePieChartData2" legName="情感属性" :colorArr="homePieColorArr" v-if="homePieChartData2 !=''" jump="emotion"></homePieChart>
                </div>
            </div>
        </div>
        <div class="box-warp mt20 clearfix">
            <div class="box-btn">
                <a class="clearfix" href="javascript:void(0);" @click="boxerSlide(1);"><i class="icons"></i></a>
                <a class="clearfix" href="javascript:void(0);" @click="boxerSlide(0);"><i class="icons"></i></a>
            </div>
            <div class="boxer" :style="[boxWidth, boxerLeft]">
                <div class="box clearfix" v-for="(item,index) in mediaList" :key="index" :class="item.class">
                    <span class="fl">
                        <i class="db num fs28">{{item.total != '' ? item.total : '0'}}</i>
                        <i class="db name">{{item.name}}</i>
                    </span>
                    <span class="fr">
                        <i class="icons" :class="item.icon"></i>
                    </span>
                    <homeLine :id="item.id" :dataArry="item.values" :colorArr="item.colors"></homeLine>
                </div>
            </div>
        </div>
        <div class="kuang mt20">
            <div class="home-line-chart">
                <homeLineChart id="hotEvent" :dataArray="hotEventData" v-if="hotEventData != ''" :colorArr="colorArr" :isShowLegend='true' :isShowArea="false" gridBot ="40"></homeLineChart>
            </div>
        </div>
        <div class="page mt20 clearfix">
            <div class="page-left wh50 fl">
                <div class="kuang">
                    <div class="kuang-header clearfix">
                        <h2 class="color-blue fl">热门文章</h2>
                    </div>
                    <div class="kuang-body new clearfix">
                        <div class="data-load" v-if="hotArticle === ''"><img src="/static/images/loading1.gif" class="img"/><span class="text color-white">获取数据中...</span></div>
                        <div class="" v-if="hotArticle !== ''">
                            <div class="no-data no-datas" v-if="hotArticle.length <= 0"><span class="text color-white">暂无数据</span></div>
                            <ul v-if="hotArticle.length > 0">
                                <li v-for="(item,index) in hotArticle" :key="index">
                                    <router-link class="title ovhidden" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}">{{item.newsTitle}}</router-link>
                                    <p class="bq">{{item.mediaName}}　{{item.newsPosttime}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-right wh50 fr">
                <div class="kuang">
                    <div class="kuang-header">
                        <h2 class="color-blue fl">最新负面舆情</h2>
                    </div>
                    <div class="kuang-body new clearfix">
                        <div class="data-load" v-if="fuList === ''"><img src="/static/images/loading1.gif" class="img"/><span class="text color-white">获取数据中...</span></div>
                        <div class="" v-if="fuList !== ''">
                            <div class="no-data no-datas" v-if="fuList.length <= 0"><span class="text color-white">暂无数据</span></div>
                            <ul v-if="fuList.length > 0">
                                <li v-for="(item,index) in fuList" :key="index">
                                    <router-link class="title ovhidden" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}">{{item.newsTitle}}</router-link>
                                    <p class="bq">{{item.mediaName}}　{{item.newsPosttime}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page mt20 clearfix">
            <div class="page-left wh50 fl">
                <div class="kuang">
                    <div class="kuang-header clearfix">
                        <h2 class="color-blue fl">政务新媒体报道</h2>
                        <div class="grid-info fl">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">指政府拥有新闻资质的媒体</p>
                        </div>
                        <router-link class="fr color-blue" :to="'/analysis/analysisDetail?type=govMedia&startDate='+startDate+'&endDate='+endDate+'&isRepeat=1'">更多</router-link>
                    </div>
                    <div class="kuang-body new clearfix">
                        <div class="data-load" v-if="govMediaList === ''"><img src="/static/images/loading1.gif" class="img"/><span class="text color-white">获取数据中...</span></div>
                        <div class="" v-if="govMediaList !== ''">
                            <div class="no-data no-datas" v-if="govMediaList.length <= 0"><span class="text color-white">暂无数据</span></div>
                            <ul v-if="govMediaList.length > 0">
                                <li v-for="(item,index) in govMediaList" :key="index">
                                    <router-link class="title ovhidden" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}">{{item.newsTitle}}</router-link>
                                    <p class="bq">{{item.mediaName}}　{{item.newsPosttime}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-right wh50 fr">
                <div class="kuang">
                    <div class="kuang-header clearfix">
                        <h2 class="color-blue fl">互联网新闻信息稿源</h2>
                        <div class="grid-info fl">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">指央媒、省媒等拥有新闻资质的媒体</p>
                        </div>
                        <router-link class="fr color-blue" :to="'/analysis/analysisDetail?type=mainMedia&startDate='+startDate+'&endDate='+endDate+'&isRepeat=1'">更多</router-link>
                    </div>
                    <div class="kuang-body new clearfix">
                        <div class="data-load" v-if="newsList === ''"><img src="/static/images/loading1.gif" class="img"/><span class="text color-white">获取数据中...</span></div>
                        <div class="" v-if="newsList !== ''">
                            <div class="no-data no-datas" v-if="newsList.length <= 0"><span class="text color-white">暂无数据</span></div>
                            <ul v-if="newsList.length > 0">
                                <li v-for="(item,index) in newsList" :key="index">
                                    <router-link class="title ovhidden" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}">{{item.newsTitle}}</router-link>
                                    <p class="bq">{{item.mediaName}}　{{item.newsPosttime}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import homeMapChart from '../../components/echart/homeMapChart.vue';
import homePieChart from '../../components/echart/homePieChart.vue';
import homeLine from '../../components/homeLine.vue';
import homeLineChart from '../../components/echart/homeLineChart.vue';
export default {
    components:{homeMapChart,homePieChart,homeLine,homeLineChart},
    data() {
        return {
            planId: '',//方案ID
            numData:'',//地图左侧数字
            boxWidth:{width:'100px'},
            boxerLeft:{left:'0'},
            left:0,
            homeMapChartData:[],//地图数据
            homePieChartData1:[],
            homePieChartData2:[],
            homePieColorArr:[['#00b8e2','#0099e2'],['#f79125','#f76a25'],['#de103d','#ec2f59']],//情感属性颜色
            hotEventData:'',//折线图数据
            colorArr:["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            mediaType:'weibo',
            mapColor:["#16aaff", "#0c1974"],//地图颜色
            govMediaList:[],//政府报道文章
            hotArticle:'',//热门文章
            fuList:[],//负面舆情
            mediaList:[],//主流媒体报道
            startDate:'',//开始时间
            endDate:'',//结束时间
            newsList:[]
        }
    },
    mounted() {
        let that = this;
        // that.mapColor = ["#ff3434", "rgba(255,52,52,.2)"];
        // that.mapColor = ["#00cc74", "rgba(0,204,116,.2)"];
		that.$nextTick(() =>{
            that.mapLeftData();//获取地图左边数字
            $('.mala-content').addClass('body-blue');
            that.homeMapChartAjax();
            that.homePieChartAjax1();
            that.homePieChartAjax2();
            that.getMediaList();
            that.getNews('all');//主流媒体
            that.getNews('fu');//负面新闻
            that.getNews('hot');//负面新闻
            that.getNews('govMedia');//负面新闻
            that.getLineData();
            // 获取近一个月时间
            // that.getMouthTime();
        })
    },
    beforeDestroy() {
        $('.mala-content').removeClass('body-blue');
    },
    created() {
        // 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        // 获取近一个月的时间
        // getMouthTime(){
        //     this.endDate = this.$utils.getNowDate();//今天时间
        //     this.startDate = this.$utils.getBeforeDay(this.endDate,30,1);//前一天
        // },
        homeMapChartAjax(){
            let that = this;
            that.$api.get('monitor/summary/map', {sid:that.planId}, r=>{
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.homeMapChartData = data;
                });
            })
        },
        // 平台分布
        homePieChartAjax1(){
            let that = this;
            that.$api.get('monitor/summary/platform', {sid:that.planId}, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.homePieChartData1 = data;
                });
            })

        },
        // 情感属性
        homePieChartAjax2(){
            let that = this;
            that.$api.get('monitor/summary/emotion', {sid:that.planId}, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.homePieChartData2 = data;
                });
            })
        },
        // 获取折线图数据
        getLineData(){
            let that = this;
            that.$api.get('monitor/summary/trend', {sid:that.planId}, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.hotEventData = data;
                });
            })
        },
        // 计算boxer宽度
        countBoxer () {
            let that = this;
            let len = that.mediaList.length;
            let wh = len*280 + (len-1)*20;
            that.boxWidth = {width:''+wh+'px'};
        },
        // boxer滑动
        boxerSlide (type) {
            let that = this;
            let left = that.left;
            let wh1 = $(".box-warp").width();
            let wh2 = $(".boxer").width();
            let cha = cha = wh2 - wh1 - Math.abs(left);
            let x = 300;//每次滑动距离
            if(type === 0){//往左
                if(cha < 300){
                    x = cha;
                }
                left-=x;
                that.left = left;
                that.boxerLeft = {left:''+left+'px'}
            }else{//往右
                if(Math.abs(left) < 300){
                    x = Math.abs(left);
                }
                left += x;
                that.left = left;
                that.boxerLeft = {left:''+left+'px'}
            }
        },
        // 地图旁边3个数据
        mapLeftData () {
            let that = this;
            that.$api.get('monitor/summary/total',{sid:that.planId},r =>{
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.numData = data;
                    that.endDate = r.data.timeMonth.endTime
                    that.startDate = r.data.timeMonth.startTime
                });
            })
        },
        // 主流媒体报道
        getMediaList () {
            let that = this;
            let color1 = ['#0092e7','rgba(0,149,235,.6)','rgba(0,149,235,0)']
            let color2 = ['#02b555','rgba(2,181,85,.6)','rgba(2,181,85,0)']
            let color3 = ['#ad5013','rgba(240,107,9,.6)','rgba(240,107,9,0)']
            let color4 = ['#cd0c38','rgba(219,12,57,.6)','rgba(219,12,57,0)']
            let color5 = ['#6c00cb','rgba(111,0,209,.6)','rgba(111,0,209,0)']
            let color6 = ['#373fc7','rgba(65,69,229,.6)','rgba(65,69,229,0)']
            let arrs = [
                {'name':'网页','enName':'web','id':'webCanvas','icon':'web-icon','total':'','values':'','colors':color1,'class':'box-bg1'},
                {'name':'微信','enName':'wx','id':'wxCanvas','icon':'wx-big-icon','total':'','values':'','colors':color2,'class':'box-bg2'},
                {'name':'微博','enName':'weibo','id':'weiboCanvas','icon':'wb-big-icon','total':'','values':'','colors':color3,'class':'box-bg3'},
                // {'name':'问答','enName':'','icon':'wd-big-icon','total':'','values':'','colors':color4,'class':'box-bg4'},
                {'name':'App','enName':'app','id':'appCanvas','icon':'app-big-icon','total':'','values':'','colors':color5,'class':'box-bg5'},
                {'name':'论坛','enName':'bbs','id':'bbsCanvas','icon':'tt-big-icon','total':'','values':'','colors':color6,'class':'box-bg6'},
                {'name':'报刊','enName':'journal','id':'journalCanvas','icon':'journal-icon','total':'','values':'','colors':color3,'class':'box-bg3'},
                {'name':'问答','enName':'aq','id':'aqCanvas','icon':'douyin-icon','total':'','values':'','colors':color1,'class':'box-bg1'},
                {'name':'视频','enName':'video','id':'videoCanvas','icon':'kuaishou-icon','total':'','values':'','colors':color5,'class':'box-bg5'},
                // {'name':'抖音','enName':'video_douyin','id':'douyinCanvas','icon':'douyin-icon','total':'','values':'','colors':color5,'class':'box-bg5'},
                // {'name':'快手','enName':'video_kuaishou','id':'kuaishouCanvas','icon':'kuaishou-icon','total':'','values':'','colors':color3,'class':'box-bg3'},
                {'name':'头条号','enName':'media_toutiao','id':'ttCanvas','icon':'toutiao-icon','total':'','values':'','colors':color4,'class':'box-bg4'},
                // {'name':'企鹅号','enName':'media_qq','id':'qqCanvas','icon':'qq-icon','total':'','values':'','colors':color1,'class':'box-bg1'},
                // {'name':'百家号','enName':'media_baijia','id':'bjCanvas','icon':'baijia-icon','total':'','values':'','colors':color6,'class':'box-bg6'},
                // {'name':'网易号','enName':'media_wangyi','id':'wyCanvas','icon':'wangyi-icon','total':'','values':'','colors':color4,'class':'box-bg4'},
                {'name':'搜狐号','enName':'media_sohu','id':'sohuCanvas','icon':'sohu-icon','total':'','values':'','colors':color3,'class':'box-bg3'},
            	{'name':'评论','enName':'comment','id':'commentCanvas','icon':'comments-icon','total':'','values':'','colors':color6,'class':'box-bg6'},
                {'name':'其他','enName':'other','id':'otherCanvas','icon':'people-icon','total':'','values':'','colors':color5,'class':'box-bg5'}
            ];
            that.$api.get('monitor/summary/media', {sid:that.planId}, r=> {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    for(let i in data){
                        for(let j of arrs){
                            let enName = j.enName;
                            if(enName === i){
                                if(data[i].values == ''){
                                    j.values = [0,0,0];
                                }else{
                                    j.values = data[i].values;
                                }
                                j.total = data[i].total;
                            }
                        }
                    }
                    that.mediaList = arrs;
                    that.countBoxer();
                });
            })
        },
        // 获取新闻
        getNews (type) {
            let that = this;
            that.$api.get('monitor/summary/news-list', {sid:that.planId,type:type}, r=> {
                that.$utils.returnCode(r,function(){
                    if(type === 'all'){
                        that.newsList = r.data;
                    }else if(type === 'fu'){
                        that.fuList = r.data;
                    }else if(type === 'hot'){//热门文章
                        that.hotArticle = r.data;
                    }else if(type === 'govMedia'){//政府文章
                        that.govMediaList = r.data;
                    }
                });
            })
        }
        // 微信微博删选
        // twoWeiTab (type) {
        //     let that = this;
        //     that.mediaType = type;
        //     that.getNews(type);
        // }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/yuYingGather.vue